import React, { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import useSettlements from '../../../hooks/teacher/useSettlements';
import SimpleLoading from '../../common/SimpleLoading';
import TabManager from '../../../pages/faculty/components/Tabs';
import TeacherInteractionButtons from '../../../pages/faculty/components/TeacherInteractionButtons';
import { tabConfigs } from '../../../pages/faculty/utils/tabConfigs';

const MainSettlements = () => {
    const { settlements, initialValues, states } = useSettlements();

    //STATES
    const [
        initialValuesWithoutCanceledOrders,
        setInitialValuesWithoutCanceledOrders,
    ] = useState(null);
    const [
        settlementsWithoutCanceledOrders,
        setSettlementsWithoutCanceledOrders,
    ] = useState(null);
    const [statesWithoutCanceledOrders, setStatesWithoutCanceledOrders] =
        useState(null);

    const [tabNewOrdersRefresh, setTabNewOrdersRefresh] = useState(false);

    //EFFECT
    useEffect(() => {
        if (!!initialValues && !!settlements && !!states) {
            setInitialValuesWithoutCanceledOrders(
                initialValues?.filter((item) => item?.initialState !== 'cancel')
            );
            setSettlementsWithoutCanceledOrders(
                settlements?.filter((item) => item?.initialState !== 'cancel')
            );
            setStatesWithoutCanceledOrders(
                states?.filter((item) => item?.id !== 'cancel')
            );
        }
    }, [initialValues, settlements, states]);

    const handleTabRefresh = () => {
        setTabNewOrdersRefresh('nuevas_ordenes');
    };

    //RETURN
    if (
        !initialValuesWithoutCanceledOrders ||
        !settlementsWithoutCanceledOrders ||
        !statesWithoutCanceledOrders
    ) {
        return <SimpleLoading />;
    }
    return (
        <MainWrapper>
            <WrapperTabs>
                <TeacherInteractionButtons handleRefresh={handleTabRefresh} />
                <TabManager
                    tabConfigs={tabConfigs}
                    newOrderSucces={tabNewOrdersRefresh}
                />
            </WrapperTabs>
        </MainWrapper>
    );
};

export default MainSettlements;

const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    height: 100%;
    min-height: 0;
`;

const WrapperTabs = styled.div`
    width: 100%;
    background-color: #fff;
    border-radius: 20px;
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;
